/** The human-readable message of an unknown thrown value — an `Error`, a
 *  Capacitor plugin rejection (`{ message, code }`), or anything else
 *  stringified. One helper so log lines and copy checks don't each re-spell
 *  the `instanceof Error ? .message : String()` chain. Never throws, since
 *  callers run it inside catch blocks: String() does on an object with no
 *  prototype or a throwing toString. */
export function errorMessage(error: unknown): string {
  try {
    if (error instanceof Error) return error.message;
    if (typeof error === "object" && error !== null && "message" in error) {
      return String((error as { message: unknown }).message);
    }
    return String(error);
  } catch {
    return "unknown error";
  }
}

/** A Capacitor plugin rejection's `code`, when it sent a string one. */
export function errorCode(error: unknown): string | undefined {
  if (typeof error !== "object" || error === null) return undefined;
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? code : undefined;
}
